import initializeComponent from 'Shared/react-initialize';
import PopupContainer from './popup_container';

initializeComponent('PopupModal', PopupContainer);
